// extracted by mini-css-extract-plugin
export default {"disabled":"div_disabled__DBYyj"};